import { render, staticRenderFns } from "./CustomfieldsModal.vue?vue&type=template&id=a766e85c"
import script from "./CustomfieldsModal.vue?vue&type=script&lang=js"
export * from "./CustomfieldsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports